import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AuthGuard, PrepareGuard, PendingChangesGuard } from 'app/core/core.module';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { ContactLogOverviewComponent } from './contact-log-overview/contact-log-overview.component';
import { ContactLogDialogComponent } from './contact-log-dialog/contact-log-dialog.component';



@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'contact-log',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'overview', pathMatch: 'full' },
                    { path: 'overview', component: ContactLogOverviewComponent, data: { title: 'Contact Log' }, canActivate: [AuthGuard, PrepareGuard] },
                ],
            },
        ]),
    ],
    declarations: [
        ContactLogOverviewComponent, ContactLogDialogComponent
    ]
})
export class ContactLogsModule {}
